// export const logout = ( state ) => {
// }

export const setProducts = (state, products) => {
    state.products = products
}

export const setProductsSelectable = (state, products) => {
    state.productsSelectable = products
}

export const setProductSelect = ( state, product ) => {
    state.productSelect = product
}

export const setProductListByTypeProductClientSelectable = (state, products) => {
    state.productListByTypeProductClientSelectable = products
}

export const setProductsPaginated = (state, productsPaginatedData) => {
    state.productsPaginatedData = productsPaginatedData
}

export const setProductDetail = (state, product) => {
    state.product = product
}

export const saveNewProducts = (state, product) => {
    state.products.unshift(product)
    state.createdData = product;
}

export const saveUpdatedProduct = (state, product) => {
    state.products.unshift(product)
    state.updatedData = product;
}

export const setDeleteProduct = (state, product) => {
    state.productsPaginatedData.data.filter(x => x.id !== product.id);
    state.deletedData = product
}

export const setProductIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setProductIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setProductIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setProductIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}

export const setProductsByLoteIsLoading = (state, productsByLoteIsLoading) => {
    state.isLoadingProductsByLote = productsByLoteIsLoading
}

export const setProductsByLote = (state, productsByLote) => {
    state.productsByLoteData = productsByLote;
}

export const saveProductByNamePresentationClient = (state, productByNamePresentationClient) => {
    state.productByNamePresentationClient = productByNamePresentationClient;
}

export const setProductByNamePresentationClientIsCreating = (state, productByNamePresentationClientIsCreating) => {
    state.productByNamePresentationClientIsCreating = productByNamePresentationClientIsCreating
}

export const setProductByNamePresentationClientTotalAmountUnitIsCreating = (state, productByNamePresentationClientTotalAmountUnitIsCreating) => {
    state.productByNamePresentationClientTotalAmountUnitIsCreating = productByNamePresentationClientTotalAmountUnitIsCreating
}

export const saveProductByNamePresentationClientTotalAmountUnit = (state, productByNamePresentationClientTotalAmountUnit) => {
    state.productByNamePresentationClientTotalAmountUnit = productByNamePresentationClientTotalAmountUnit;
}

export const setProductListByClientIsLoading = (state, isLoading) => {
    state.isLoadingProductListByClient = isLoading
}

export const setProductListByClientSelectable = (state, products) => {
    state.productListByClientSelectable = products
}